import React from "react";
import PropTypes from "prop-types";
import { Menu } from "@mui/material";
import { MButton } from "../../M_Components";

export default function ViewsMenu({
    anchorEl,
    open,
    onClose,
    viewsMap,
    onSelectDefault,
    onSelectView,
    onCreateNewViewClick
}) {
    return (
        <Menu // Views Menu to select different views for the table
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Positioning the menu
            transformOrigin={{ vertical: "top", horizontal: "center" }} // Transform origin for the menu
            anchorEl={anchorEl} // Anchor element for the menu
            open={open} // Whether the menu is open or not
            onClose={onClose} // Function to call when the menu is closed
            className="menuViews" // Custom class for styling
            MenuListProps={{ disablePadding: true }} // Disable padding for the menu list
        >
            <div
                className="stickyTop center"
                style={{ borderBottom: "1px solid var(--color-grey-light)", marginBottom: "5px" }}
            >
                <MButton // Button to select the default view
                    width={30}
                    hoverEffect
                    label={"Default"}
                    backgroundColor={"var(--color-grey-light)"}
                    labelColor={"var(--color-black)"}
                    onClick={onSelectDefault}
                    clickFunction={onSelectDefault}
                />
            </div>

            {Array.from((viewsMap || new Map()).keys()).map((view) => // Iterate through the views in the map
                view !== "Default" ? ( // If not the default view
                    <div className="midleViews menuitem" key={view}>
                        <MButton // Button for each view
                            width={60}
                            hoverEffect
                            label={view}
                            backgroundColor={"var(--color-white)"}
                            labelColor={"var(--color-black)"}
                            onClick={() => onSelectView(view)}
                            clickFunction={() => onSelectView(view)} // Function to call when the view is selected
                        />
                    </div>
                ) : null
            )}

            <div className="stickyBot center">
                <MButton // Button to create a new view
                    icon={<i className="pi pi-plus-circle" style={{ fontSize: "1rem", color: "var(--color-white)" }} />}
                    hoverEffect
                    backgroundColor={"var(--color-green)"}
                    labelColor={"var(--color-white)"}
                    onClick={onCreateNewViewClick}
                    clickFunction={onCreateNewViewClick} // Function to call when creating a new view
                    label={`Create New View`}
                    width={25}
                />
            </div>
        </Menu>
    );
}

ViewsMenu.propTypes = {
    anchorEl: PropTypes.any,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    viewsMap: PropTypes.instanceOf(Map).isRequired,
    onSelectDefault: PropTypes.func.isRequired,
    onSelectView: PropTypes.func.isRequired,
    onCreateNewViewClick: PropTypes.func.isRequired
};
